import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@components/base';

import useFilterDialog from './hooks/useFilterDialog';

const AddRootLevelFilterGroupButton: FC = () => {
  const { t } = useTranslation();
  const { addRootLevelFilterGroup } = useFilterDialog();

  return (
    <Button leftIcon='add' onClick={addRootLevelFilterGroup} sx={{ mr: 'auto' }}>
      {t('filter.addGroup')}
    </Button>
  );
};

export default AddRootLevelFilterGroupButton;
